<div class="third-party">
    <h3 class="third-party-header">Payment by 3rd party</h3>
    <p>
        This option means that your company or a 3rd party will pay the fees.<br />
        Please provide comment on who will be submitting the payment.
    </p>
    <span class="comment-label required">Comment</span> :
    <textarea [(ngModel)]="commentText" class="comment-input" cols="40" rows="3"></textarea>
</div>
<div class="modal-footer footer-container">
    <button type="button" class="btn btn-default" (click)="goToInitial()">BACK</button>
    <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
    <button [disabled]="!commentText" type="button" class="btn btn-primary" (click)="onConfirm()">CONFIRM</button>
</div>
